import { CloseIcon } from '@shared/ui/CloseIcon';
import { Modal } from '@shared/ui/Modal';

import cls from './Reviews.module.scss';

type PublicationRulesModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const PublicationRulesModal = ({ isOpen, onClose }: PublicationRulesModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    contentClassName={cls.rulesModal}
  >
    <CloseIcon
      className={cls.rulesModalClose}
      onClick={onClose}
    />
    <h2 className={cls.rulesModalTitle}>Правила публикации пользовательского контента</h2>
    <div className={cls.rulesModalContent}>
      <div className={cls.rulesModalSection}>
        <p className={cls.rulesModalSubtitle}>Как написать хороший отзыв?</p>
        <ul className={cls.rulesModalList}>
          <li>Сфокусируйте внимание на предмете вашего отзыва.</li>
          <li>Укажите причину, почему Вам понравился/не понравился данный товар.</li>
          <li>Будьте вежливы и соблюдайте грамотность.</li>
        </ul>
      </div>

      <p>Публикация контента происходит только после их предварительной модерации. Обычно это занимает до 5 дней.</p>

      <div className={cls.rulesModalSection}>
        <p className={cls.rulesModalSubtitle}>Отзыв не будет опубликован, если:</p>
        <ul className={cls.rulesModalList}>
          <li>содержит нецензурную лексику или любые оскорбления,</li>
          <li>содержит большое количество лексических, орфографических и других ошибок,</li>
          <li>набран латинскими буквами или буквами в верхнем регистре,</li>
          <li>отзыв рекламного характера (номера телефонов, адреса, ссылки на другие сайты),</li>
          <li>текст отзыва не относится к товару,</li>
          <li>отзыв относится к обслуживанию в магазине.</li>
        </ul>
      </div>

      <p>
        Просим с пониманием отнестись к тому, что редакторы сайта оставляют за собой право скорректировать отзывы, в
        соответствии с перечисленным выше требованиями. А также оставляют за собой право удалить любой отзыв в любое
        время без объяснения причин и без предварительного согласования с автором отзыва.
      </p>
    </div>
  </Modal>
);
